import { PrimaryControlsStripToolbar } from "@-/dev.improve.haniverse.routes.nav._components.primary-controls-strip.toolbar";
import { BrowseLevelsLayoutContextProvider } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.levels._context";
import { BrowseLevelsLayoutContent } from "#browse-levels-layout-content";
import { LazyBrowseTabContent } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs._lib.focus";
import { LevelSurfacesLoadingPage } from "@-/dev.improve.haniverse.routes.nav.app._components.level.surface";
import { View } from "@-/com.npmjs.react-native";
import { CustomLevelsProvider } from "@-/dev.improve.haniverse.routes.nav.app.browse.tabs.levels.custom";

export function BrowseLevelsLayout() {
  return (
    <LazyBrowseTabContent fallback={<BrowseLevelsLoadingShell />}>
      <BrowseLevelsLayoutBody />
    </LazyBrowseTabContent>
  );
}

// Native tabs can display this scene before React receives focus. Keep this preview data-free;
// the real provider (including study queries and the level catalog) still mounts on first visit.
function BrowseLevelsLoadingShell() {
  return (
    <View className="min-h-0 flex-1 bg-background">
      {/* The same bar as `BrowseLevelsToolbar`, without its actions while the catalog loads. */}
      <PrimaryControlsStripToolbar className="relative shrink-0" stripFade={false} />
      <View accessibilityElementsHidden className="h-9 flex-row gap-2 px-3">
        {[0, 1, 2, 3].map((grade) => (
          <View className="my-2 flex-1 rounded-xs bg-muted" key={grade} />
        ))}
      </View>
      <LevelSurfacesLoadingPage />
    </View>
  );
}

function BrowseLevelsLayoutBody() {
  return (
    <CustomLevelsProvider>
      <BrowseLevelsLayoutContextProvider>
        <BrowseLevelsLayoutContent />
      </BrowseLevelsLayoutContextProvider>
    </CustomLevelsProvider>
  );
}
